export default __webpack_public_path__ + "static/media/cow.470ad201.png";